import { useInView } from 'react-intersection-observer';
import React from 'react';
import styled from 'styled-components';
import SectionTitle from '../../Components/SectionTitle';
import FadeInSection from '../../Components/FadeInSection';

const ContactContainer = styled.div`
  padding-top: 120px;
  text-align: center;
`;

const ContactText = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 18px;
  color: #333333;
  margin-top: 30px;
`;

function Contact() {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.7,
    });

    return (
        <ContactContainer ref={ref}>
            <SectionTitle $animate={inView}>
                Contact
            </SectionTitle>

            <FadeInSection>
                <ContactText>
                    Feel free to reach out through my social networks.
                </ContactText>
            </FadeInSection>
        </ContactContainer>
    );
}

export default Contact;